import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { isDefined } from '@trimble-gcs/common';
import { TranslationService } from '@trimble-gcs/i18n';
import { LocaleId, supportedLocales } from '@trimble-gcs/i18n-types';
import { filter, switchMap } from 'rxjs';
import { SetLocale } from './locale.state';

@UntilDestroy()
@Component({
  selector: 'sd-locale-select',
  imports: [CommonModule, ReactiveFormsModule, MatSelectModule],
  templateUrl: './locale-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocaleSelectComponent {
  private readonly store = inject(Store);
  private readonly translationService = inject(TranslationService);

  readonly localeControl = new FormControl<LocaleId | undefined>(undefined, { nonNullable: true });
  readonly localeList = Object.keys(supportedLocales).sort();

  constructor() {
    this.subscribeToLocaleChange();

    // Set current locale as selected
    this.localeControl.reset(this.translationService.currentLocale, { emitEvent: false });
  }

  private subscribeToLocaleChange() {
    this.localeControl.valueChanges
      .pipe(
        filter(isDefined),
        switchMap((locale) => this.store.dispatch(new SetLocale(locale))),
        untilDestroyed(this),
      )
      .subscribe(() => window.location.reload());
  }
}
